import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase";
import { isActiveAdminRecord } from "./phoenixHub/bookingUtils";

/**
 * Admin gate:
 * - If not logged in -> /admin-login
 * - If logged in but not on allowlist -> Access denied
 *
 * Allowlist in Firestore:
 *   admins/<uid> { active: true }
 */
export default function RequireAdmin({ children }) {
  const [state, setState] = useState({
    loading: true,
    user: null,
    isAdmin: false,
  });

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({ loading: false, user: null, isAdmin: false });
        return;
      }

      try {
        const ref = doc(db, "admins", user.uid);
        const snap = await getDoc(ref);
        const isAdmin = snap.exists() && isActiveAdminRecord(snap.data());
        setState({ loading: false, user, isAdmin });
      } catch {
        setState({ loading: false, user, isAdmin: false });
      }
    });

    return () => unsub();
  }, []);

  if (state.loading) return <div className="p-4 text-white">Checking access…</div>;
  if (!state.user) return <Navigate to="/admin-login" replace />;
  if (!state.isAdmin) return <div className="p-4 text-white">Access denied.</div>;

  return children;
}
